import React from 'react';

import './career.css'; // optional, for custom styles

function Careers() {
  return (
    <div className="careers-container" style={{ display: 'flex', flexWrap: 'wrap', padding: '2rem' }}>
      <div style={{ flex: '1 1 50%', paddingRight: '2rem' }}>
        <h2>Contact Information</h2>
        <hr/>
        <p>
          Inovaantage is a young and dynamic consultancy firm helping to shape talents in a fast-moving industry
          keeping pace with technology evolution and skill set. Here people learn and grow with the pace of
          industry with vast domain knowledge of industry leaders. We always encourage our people to take part
          in challenging environments and innovate new processes for solving complex issues for generating
          maximum value for our partners within laid out regulations. We recognise our people are real assets
          and human capital development is fundamental to our success.
        </p>
      </div>

      <div style={{
        flex: '1 1 40%',
        padding: '2rem',
        background: '#fff',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ fontWeight: 'bold' }}>
          <span style={{ color: '#1E40AF' }}>INOVA</span><span style={{ color: '#EA580C' }}>ANTAGE</span>
        </h2>
        <h3 style={{ marginBottom: '1rem' }}>Apply Now</h3>
        <form>
          <input type="text" placeholder="Name" required style={inputStyle} />
          <input type="email" placeholder="Email*" required style={inputStyle} />
          <input type="tel" placeholder="Phone*" required style={inputStyle} />
          <button type="submit" style={buttonStyle}>
            <span role="img" aria-label="send">📨</span> Send Application
          </button>
        </form>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  padding: '10px',
  marginBottom: '1rem',
  border: '1px solid #ccc',
  borderRadius: '5px'
};

const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#e35f00',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
};

export default Careers;
